import React,{Component} from "react";
import {AppBackground, MediumFont, TextColor, ThinBorder} from '../../styles/BaseStyles';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import MoneyCard from "./MoneyCard";
import TimeCard from "./TimeCard";
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import {bindActionCreators} from "redux";
import {loginAction} from "../../redux/modules/login";
import {connect} from "react-redux";
import * as MainConstants from "../../utils/MainConstants";
import Image from 'material-ui-image'
import {Link} from "react-router-dom";
import ContactUs from "./ContactUs";
import Divider from "@material-ui/core/Divider";
//import GridBase from "@material-ui/core/Grid";


/*const Grid = styled(GridBase)`
  .MuiGrid-root {
    flex-grow: 1;
  }*/

const Styles = theme => ({
  root: Object.assign({}, AppBackground, MediumFont),
  gridPane: {width: '50%', display: 'inline-block'},
  paneTable: {width: '100%', height: '100%',  backgroundColor:'grey'},
  videoPane: {width: '50%', display: 'inline-block', verticalAlign: 'top'},
  penInfoPanel: {color: 'white', fontSize: 20},
  penInfoPanelSelected: Object.assign({color: 'white', fontSize: 20}, ThinBorder),
  videoPanel: {marginTop: 0},
  penName: {color: TextColor, fontSize: 20, marginLeft: 10, cursor: 'pointer', display: 'inline-block'},
  metricValue: {display: 'inline-block', width: 100, height: 100, cursor: 'pointer'},
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: `${theme.spacing.unit * 3}px`,
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  divider: {
    margin: `${theme.spacing.unit * 2}px 0`,
  },
  metricInfo: Object.assign({}, AppBackground, ThinBorder)

});

const styles = theme => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: `${theme.spacing.unit * 3}px`,
  },
  paper: {
    padding: theme.spacing.unit,
    textAlign: 'center',
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    marginBottom: theme.spacing.unit,
  },
  divider: {
    margin: `${theme.spacing.unit * 2}px 0`,
  },
  leftPane: {width: '25%', height: '100%', verticalAlign: 'top', backgroundColor:'red'},
  rightPane: {fontSize: 40, color: 'black', verticalAlign: 'top', backgroundcolor:'red'},
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  button: {
    margin: theme.spacing.unit,
  },
  extendedIcon: {
    marginRight: theme.spacing.unit,
  },
  margin: {
    margin: theme.spacing.unit * 2,
  },
  dividerColorPurpole: {
    //marginTop: theme.spacing.unit * 3,
    height: '20px',
    color:"#ffffff",
    //backgroundColor:"#760eb3",
  },
});


class SaveTime extends Component {

  state = {
    age: '',
    name: 'hai',
  };

  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  constructor(props) {
    super(props);
    this.towAgentClick = this.towAgentClick.bind(this);
    this.vehicleOwnerClick = this.vehicleOwnerClick.bind(this);
  }


  towAgentClick(){
    //alert("was called") ;
    this.props.towAgentConfigCall();

  }

  vehicleOwnerClick(){
    let { loginAction } = this.props;
    //this.props.auth.login();
    loginAction();
    //alert("was called") ;
    //this.props.vehicleOwnerConfigCall();

  }

  render() {
    const { classes, theme } = this.props;
    //const bull = <span className={classes.bullet}>•</span>;
    window.scrollTo(0, 0);
    return (
      <div id="top1"  style={{ backgroundColor:"#F2F6F8" }}>

        <Grid container spacing={24}  >
          <Grid   item xs={12} sm={12}  md={12} lg={12}   xl={12} >
            <div  style={{ marginLeft:15, marginRight:15,  marginTop:10}}>
              <Typography component="h4" variant="h5"   style = { { textAlign: 'left', alignSelf: 'left'  , color:'black'}}gutterBottom>
                <Typography component="h6" variant="h6"   style = { { textAlign: 'center', alignSelf: 'center' ,paddingTop:'0', marginTop:'0', fontWeight:'800', color:'#e2580d'}} >______________________________</Typography>
                <Typography component="h1" variant="h4"   style = { { textAlign: 'center', alignSelf: 'center' , fontWeight:'800', color:'#e2580d'}} >______________________________</Typography>
              </Typography>
              <br/>
              <Typography component="h1" variant="h4"   style = { {  textAlign: 'center', alignSelf: 'center'  ,backgroundColor:'transparent' , color:'black'}} >Privacy Policy for {MainConstants.APPLICATION_NAME} SMS Services
              </Typography>
              <Typography component="h1" variant="h4"   style = { { textAlign: 'center', alignSelf: 'center' , fontWeight:'800', color:'#e2580d'}} >______________________________</Typography>

              <Typography component="h6" variant="h6"   style = { { textAlign: 'center', alignSelf: 'center' ,paddingTop:'0', marginTop:'0', fontWeight:'800', color:'#e2580d'}} >______________________________</Typography>

              <br/>
              <div  style={{ marginLeft:15, marginRight:15, marginTop:10}}>
                <Typography component="h2" variant="h5"   style = { { textAlign: 'left', alignSelf: 'left'  , color:'black'}}gutterBottom>
                  Thank you for choosing {MainConstants.APPLICATION_NAME}. This Privacy Policy describes how we collect, use, disclose, and protect the personal information of
                  users who receive and interact with SMS messages sent by {MainConstants.APPLICATION_NAME}.</Typography>
                <Typography variant="h5"    component="h2" style = { {  color:'#BF360C' }}>
                </Typography>
              </div>

              <Typography   variant="subtitle1">
                <ol>
                  <li style = { { textAlign: 'left', alignSelf: 'left' , fontWeight:'bold', fontSize:20, color:'#BF360C'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontWeight:'bold', fontSize:20, color:'#BF360C'}} > Information We Collect </span>
                    <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, fontWeight:'400', color:'black'}}> In connection with the SMS services provided by {MainConstants.APPLICATION_NAME}, we may collect the following types of information:</span> </li>
                  <ul style={{ listStyleType: 'disc' }} >

                    <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20 ,  color:'#e2580d'}} > Mobile Phone Number:</span>
                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> We collect your mobile phone number when you opt-in to receive SMS messages from us.</span> </li>
                    <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20,   color:'#e2580d'}} > Interaction Data:</span>
                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Information on how you interact with the SMS messages we send, such as whether you open messages, click links within them, or respond to our messages.</span> </li>
                    <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20,   color:'#e2580d'}} > Technical Data:</span>
                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Information including, but not limited to, device identifiers, device type, operating system, and network information related to the messages received and sent.</span> </li>

                  </ul>

                  <li style = { { textAlign: 'left', alignSelf: 'left' , fontWeight:'bold', fontSize:20, color:'#BF360C'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontWeight:'bold', fontSize:20, color:'#BF360C'}} > How We Use Your Information </span>
                    <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, fontWeight:'400',color:'black'}}> The information collected through our SMS services is used to:</span> </li>
                  <ul style={{ listStyleType: 'disc' }} >

                    <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} ></span>
                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Send you SMS messages regarding our services, updates, promotions, and more, in accordance with your preferences.</span> </li>
                    <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} ></span>
                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Analyze and enhance our SMS offerings, including optimizing timing and frequency of messages, and developing new services.</span> </li>
                    <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} ></span>
                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Improve security, including preventing fraud and enforcing our terms and conditions.</span> </li>

                  </ul>

                  <li style = { { textAlign: 'left', alignSelf: 'left' ,  fontWeight:'bold', fontSize:20, color:'#BF360C'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontWeight:'bold', fontSize:20, color:'#BF360C'}} > Disclosure of Your Information </span>
                    <span style = { { textAlign: 'left', alignSelf: 'left' , fontWeight:'400', fontSize:18, color:'black'}}> We may share your information with third parties in the following circumstances:</span> </li>
                  <ul style={{ listStyleType: 'disc' }} >

                    <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20,   color:'#e2580d'}} >Service Providers:</span>
                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> We may share your information with service providers who perform services on our behalf, such as data hosting and telecommunications services.</span> </li>
                    <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20,   color:'#e2580d'}} >By Law or to Protect Rights:</span>
                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> We may disclose your information where required by law, subpoena, or other legal processes, or if we believe such action is necessary to protect the rights, property, or safety of {MainConstants.APPLICATION_NAME}, our customers, or others.</span> </li>

                  </ul>

                  <li style = { { textAlign: 'left', alignSelf: 'left' ,fontWeight:'bold', fontSize:20, color:'#BF360C'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontWeight:'bold', fontSize:20, color:'#BF360C'}} > Security of Your Information</span>
                    <span style = { { textAlign: 'left', alignSelf: 'left' ,fontWeight:'400', fontSize:18, color:'black'}}> We implement a variety of security measures designed to protect the security of any personal information we process. However, please also remember that we cannot guarantee
                                                      that the internet itself is 100% secure. Although we will do our best to protect your
                                                      personal information, transmission of personal information to and from our SMS service is at your own risk.</span> </li>
                  <li style = { { textAlign: 'left', alignSelf: 'left' , fontWeight:'bold', fontSize:20, color:'#BF360C'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontWeight:'bold', fontSize:20, color:'#BF360C'}} > Your Choices</span>
                    <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, fontWeight:'400',color:'black'}}> You may opt-out of receiving SMS messages from {MainConstants.APPLICATION_NAME} at any time by texting "STOP" to the SMS you receive.
                                                      Upon receiving your opt-out request, we will send you one final message confirming that you will no longer receive messages from us.</span> </li>

                  <li style = { { textAlign: 'left', alignSelf: 'left' , fontWeight:'bold', fontSize:20, color:'#BF360C'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontWeight:'bold', fontSize:20, color:'#BF360C'}} > Changes to This Privacy Policy</span>
                    <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, fontWeight:'400',color:'black'}}> We may update this Privacy Policy periodically to reflect changes in our practices, technology, legal requirements, and other factors. We encourage you to review this policy regularly to stay informed
                                                      about how we are protecting the information we collect.</span> </li>

                  <li style = { { textAlign: 'left', alignSelf: 'left' , fontWeight:'bold', fontSize:20, color:'#BF360C'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontWeight:'bold', fontSize:20, color:'#BF360C'}} > Opt-Out from Communications</span>
                    <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, fontWeight:'400',color:'black'}}> We respect your preferences and understand that you may wish to limit the communications you receive from us. If you no longer want to
                      receive updates, promotions, or newsletters, you can easily opt out by clicking the link below:</span>

                  <a href="/optout"   rel="noreferrer" style={{paddingLeft:10, display: 'flex', flexDirection: 'row', justifyContent: 'left' }}>
                    <Typography component="h2" variant="body1" style = { { color:'blue'}} >Opt out from communications
                    </Typography>
                  </a>
                    <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, fontWeight:'400',color:'black'}}> Once you opt out, you will no longer receive any promotional or marketing emails from us,
                      though you may still receive important account-related notifications.If you change your mind in the future,
                      you can always subscribe again by visiting our website or contacting our support team.</span>

                  </li>

                  <li style = { { textAlign: 'left', alignSelf: 'left' , fontWeight:'bold', fontSize:20, color:'#BF360C'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontWeight:'bold', fontSize:20, color:'#BF360C'}} > Opt-Out of Service Participation</span>
                    <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, fontWeight:'400',color:'black'}}> If you wish to discontinue your participation in {MainConstants.APPLICATION_NAME} Service, please click the link below to opt out:</span>

                    <a href="/optout"   rel="noreferrer" style={{paddingLeft:10, display: 'flex', flexDirection: 'row', justifyContent: 'left' }}>
                      <Typography component="h2" variant="body1" style = { { color:'blue'}} >Opt out from service
                      </Typography>
                    </a>
                    <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, fontWeight:'400',color:'black'}}> By opting out, you will no longer be part of {MainConstants.APPLICATION_NAME} Service, and your associated data will be handled according to our privacy policy.
                      If you need assistance or have any questions, please contact our support team.</span>

                  </li>

                  <li style = { { textAlign: 'left', alignSelf: 'left' , fontWeight:'bold', fontSize:20, color:'#BF360C'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontWeight:'bold', fontSize:20, color:'#BF360C'}} > Contact Us</span>
                    <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, fontWeight:'400',color:'black'}}> If you have questions or concerns about our privacy practices or this Privacy Policy, please use the link below to contact us.</span>

                    <div>
                      {/*<span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Email: </span>
                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'blue'}}> support@platewiz.com </span>*/}
                      <div style = { { marginLeft:'20'}}>
                        {/*<span style = { { textAlign: 'left', alignSelf: 'left' ,   fontSize:18, color:'black'}}> Phone: </span>
                        <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'blue'}}> (617) 939-6086 </span>*/}
                        <a href="/contactus"  rel="noreferrer" style = { { textAlign: 'left', alignSelf: 'center'}}>
                          <Typography component="h1" variant="h6" style = { { color:'blue'}} >
                            Contact Us
                          </Typography>
                        </a>
                      </div>
                    </div>
                  </li>
                </ol>
              </Typography> {/*End Of SMS Privacy Policy */}

              {/*<ul>
                                              <li><Link to="/home"> Go Back </Link></li>
                                              </ul>  */}
              <a href="/home"  rel="noreferrer"   style = { { textAlign: 'center', alignSelf: 'center'}}>
                <Typography component="h1" variant="h6" style = { { color:'blue'}} >
                  Back to Orchima Home
                </Typography>
              </a>
              <br/>
              <br/>





            </div>
          </Grid>
          {/*} <Grid   item xs={12} sm={12}  md={4} lg={4}   xl={4}  >
            <div  style={{ marginRight:10, marginLeft:10, marginTop:10,  marginBotton:10}}>
              <Image
                //src="/static/images/IMG_3615.JPG"
                src="/static/images/tow1a.png"
                aspectRatio='(9/6)'
              />
            </div>
          </Grid> */}




          <Grid   item xs={12} sm={12}  md={12} lg={12}   xl={12} >
            <div  style={{   marginLeft:15, marginRight:15,marginTop:10}}>
              <Typography component="h4" variant="h5"   style = { { textAlign: 'left', alignSelf: 'left'  , color:'black'}}gutterBottom>

              </Typography>
              <Typography component="h6" variant="h6"   style = { { textAlign: 'center', alignSelf: 'center' ,paddingTop:'0', marginTop:'0', fontWeight:'800', color:'#e2580d'}} >_______________________</Typography>
              <Typography component="h1" variant="h4"   style = { { textAlign: 'center', alignSelf: 'center' , fontWeight:'800', color:'#e2580d'}} >___________________</Typography>
              <br/>

              <Typography component="h1" variant="h4"   style = { { textAlign: 'center', alignSelf: 'center' ,backgroundColor:'transparent' , color:'black'}} >Privacy Policy for {MainConstants.APPLICATION_NAME}</Typography>

              <Typography component="h1" variant="h4"   style = { { textAlign: 'center', alignSelf: 'center' , fontWeight:'800', color:'#e2580d'}} >___________________</Typography>

              <Typography component="h6" variant="h6"   style = { { textAlign: 'center', alignSelf: 'center' ,paddingTop:'0', marginTop:'0', fontWeight:'800', color:'#e2580d'}} >_______________________</Typography>

              <div  style={{   marginLeft:15, marginRight:15,marginTop:10}}>
                <Typography  component="h2" variant="h5"  style = { { textAlign: 'left', alignSelf: 'left'  , color:'black'}}gutterBottom>
                  Welcome to {MainConstants.APPLICATION_NAME}, a service/app that is used by vehicle owners and tow company agents to eliminate the hassle of retrieving towed vehicles. We are committed to protecting your privacy and ensuring that your personal information
                  is handled responsibly. This Privacy Policy explains how we collect, use,
                  disclose, and safeguard your information when you use our mobile/web application.</Typography>
                <Typography variant="h5"    component="h2" style = { {  color:'#BF360C' }}>
                </Typography>
              </div>

              <Typography   variant="subtitle1">
                <ol>
                  <li style = { { textAlign: 'left', alignSelf: 'left' , fontWeight:'bold', fontSize:20, color:'#BF360C'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontWeight:'bold', fontSize:20, color:'#BF360C'}} > Information We Collect </span>
                    <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, fontWeight:'400', color:'black'}}> We may collect information about you in various ways. The information we may collect via the application includes:</span> </li>
                  <ul style={{ listStyleType: 'disc' }} >

                    <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Personal Data:</span>
                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Personally identifiable information, such as your name, address, email address, and telephone number, that you voluntarily give to us when you choose to
                        participate in various activities related to the application.</span> </li>
                    <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Derivative Data:</span>
                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Information our servers automatically collect when you access the app, such as your IP address, device type, operating system, and usage statistics.</span> </li>
                    <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Financial Data:</span>
                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Financial information, such as data related to your payment method (e.g., valid credit card number, card brand, expiration date) that we may collect when you purchase, order,
                        return, exchange, or request information about our services from the app.</span> </li>

                  </ul>

                  <li style = { { textAlign: 'left', alignSelf: 'left' , fontWeight:'bold', fontSize:20, color:'#BF360C'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontWeight:'bold', fontSize:20, color:'#BF360C'}} > Use of Your Information </span>
                    <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, fontWeight:'400',color:'black'}}> We use the information we collect about you to:</span> </li>
                  <ul style={{ listStyleType: 'disc' }} >

                    <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} ></span>
                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Provide, operate, and maintain our app.</span> </li>
                    <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} ></span>
                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Improve, personalize, and expand our app.</span> </li>
                    <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} ></span>
                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Understand and analyze how you use our app.</span> </li>
                    <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} ></span>
                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}>Develop new products, services, features, and functionality.</span> </li>
                    <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} ></span>
                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}>Communicate with you, either directly or through one of our partners, including for customer service, to provide you with updates and other
                        information relating to the app, and for marketing and promotional purposes.</span> </li>
                    <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} ></span>
                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}>Process your transactions.</span> </li>
                    <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} ></span>
                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}>Send you push notifications regarding your account or the app.</span> </li>

                  </ul>

                  <li style = { { textAlign: 'left', alignSelf: 'left' , fontWeight:'bold', fontSize:20, color:'#BF360C'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontWeight:'bold', fontSize:20, color:'#BF360C'}} > Disclosure of Your Information </span>
                    <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, fontWeight:'400',color:'black'}}> We may share information we have collected about you in certain situations. Your information may be disclosed as follows:</span> </li>
                  <ul style={{ listStyleType: 'disc' }} >

                    <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} >By Law or to Protect Rights: </span>
                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> If we believe the release of information about you is necessary to respond to legal process, to investigate or remedy potential violations of our policies, or to protect the rights, property, and safety of others, we may share
                        your information as permitted or required by any applicable law, rule, or regulation.</span> </li>
                    <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} >Third-Party Service Providers: </span>
                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}>We may share your information with third parties that perform services for us or on our behalf, including payment processing, data analysis,
                        email delivery, hosting services, customer service, and marketing assistance.</span> </li>
                    <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} >Marketing Communications: </span>
                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}>With your consent, or with an opportunity for you to withdraw consent, we may share your information with third parties for marketing purposes,
                        as permitted by law.</span> </li>

                  </ul>

                  <li style = { { textAlign: 'left', alignSelf: 'left' , fontWeight:'bold', fontSize:20, color:'#BF360C'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontWeight:'bold', fontSize:20, color:'#BF360C'}} > Security of Your Information</span>
                    <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, fontWeight:'400',color:'black'}}> We use administrative, technical, and physical security measures to help protect your personal information.
                      While we have taken
                      reasonable steps to secure the personal information you provide to us, please be aware that despite our efforts, no security measures are perfect or impenetrable,
                      and no method of data transmission can be guaranteed against any interception or other type of misuse.</span> </li>


                  <li style = { { textAlign: 'left', alignSelf: 'left' , fontWeight:'bold', fontSize:20, color:'#BF360C'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontWeight:'bold', fontSize:20, color:'#BF360C'}} > Changes to This Privacy Policy</span>
                    <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, fontWeight:'400',color:'black'}}> We may update this Privacy Policy from time to time in order to reflect, for example,
                      changes to our practices or for other operational, legal, or regulatory reasons.</span> </li>

                  <li style = { { textAlign: 'left', alignSelf: 'left' , fontWeight:'bold', fontSize:20, color:'#BF360C'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontWeight:'bold', fontSize:20, color:'#BF360C'}} > Contact Us</span>
                    <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, fontWeight:'400', color:'black'}}> If you have questions or comments about this Privacy Policy, please use link the below to contact us. </span>
                    <div>
                      {/*<span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Email: </span>
                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'blue'}}> support@platewiz.com </span>*/}
                      <div style = { { marginLeft:'20'}}>
                        {/*<span style = { { textAlign: 'left', alignSelf: 'left' ,   fontSize:18, color:'black'}}> Phone: </span>
                        <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'blue'}}> (617) 939-6086 </span>*/}
                        <a href="/contactus"  rel="noreferrer" style = { { textAlign: 'left', alignSelf: 'center'}}>
                          <Typography component="h1" variant="h6" style = { { color:'blue'}} >
                            Contact Us
                          </Typography>
                        </a>
                      </div>

                    </div>

                  </li>
                </ol>
              </Typography> {/*End Of SMS Privacy Policy */}

              {/*<ul>
                                              <li><Link to="/home"> Go Back </Link></li>
                                              </ul>  */}
              <a href="/home"  rel="noreferrer" style = { { textAlign: 'center', alignSelf: 'center'}}>
                <Typography component="h1" variant="h6" style = { { color:'blue'}} >
                  Back to Orchima Home
                </Typography>
              </a>
              <br/>





            </div>
          </Grid>
          {/*<Grid   item xs={12} sm={12}  md={4} lg={4}   xl={4}  >
            <div  style={{ marginRight:10, marginLeft:10, marginTop:10,  marginBotton:10}}>
              <Image
                //src="/static/images/IMG_3615.JPG"
                src="/static/images/tow1a.png"
                aspectRatio='(9/6)'
              />
            </div>
          </Grid>*/}
          {/*}
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
            <Divider className={classes.dividerColorPurpole}></Divider>
            <div  style={{ backgroundColor:"#f4f3ed"  }}>
              <ContactUs> </ContactUs>
            </div>
          </Grid>
          */}

        </Grid>
      </div>


    );
  }
}

const mapStateToProps = (state) => {
  return {

  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    loginAction:loginAction,


  }, dispatch);
};


SaveTime.propTypes = {
  classes: PropTypes.object.isRequired,
};
//export default BiomassView;
//export default withStyles(styles, { withTheme: true })(SaveTime);

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(SaveTime));
